import { Middleware } from '@reduxjs/toolkit';

import { debug } from '@/shared/lib';

import { transcriptorModel } from '@/entities/transcriptor';

const {
  completeRecording,
  pauseRecording,
  resetRecording,
  resumeRecording,
  startRecording,
  stopRecording,
  updateRecordingTime,
  updateUploadProgress,
} = transcriptorModel.actions;

let recordingInterval: NodeJS.Timeout | null = null;
let uploadInterval: NodeJS.Timeout | null = null;

export const recordingMiddleware: Middleware =
  (store) => (next) => (action) => {
    const result = next(action);

    if (startRecording.match(action) || resumeRecording.match(action)) {
      if (recordingInterval) {
        clearInterval(recordingInterval);
      }

      recordingInterval = setInterval(() => {
        const state = store.getState();
        const currentTime = state.transcriptor.recording.recordingTime;
        store.dispatch(updateRecordingTime(currentTime + 1));
      }, 1000);
    }

    if (
      pauseRecording.match(action) ||
      stopRecording.match(action) ||
      resetRecording.match(action)
    ) {
      if (recordingInterval) {
        clearInterval(recordingInterval);
        recordingInterval = null;
      }
    }

    if (resetRecording.match(action) && uploadInterval) {
      clearInterval(uploadInterval);
      uploadInterval = null;
    }

    if (stopRecording.match(action)) {
      if (uploadInterval) {
        clearInterval(uploadInterval);
        uploadInterval = null;
      }

      let progress = 0;

      try {
        uploadInterval = setInterval(() => {
          progress += 10;
          store.dispatch(updateUploadProgress(progress));

          if (progress >= 100) {
            if (uploadInterval) {
              clearInterval(uploadInterval);
              uploadInterval = null;
            }
            setTimeout(() => {
              store.dispatch(completeRecording());
            }, 500);
          }
        }, 300);
      } catch (error) {
        debug('Error in upload simulation:', error);
        if (uploadInterval) {
          clearInterval(uploadInterval);
          uploadInterval = null;
        }
      }
    }

    return result;
  };
